<template>
  <aside class="aside-menu" :class="{ 'aside-menu-active': menuOpen }">
    <div class="aside-menu-itens">
      <div class="aside-menu-itens-header">
        <router-link
          tag="a"
          :to="{ name: 'Welcome' }"
          @click.native="setMenuOpen(false)"
          class="aside-menu-itens-header--logo"
        >
          <img
            class="img-fluid"
            src="@/assets/img/logo-desenvolvimento-pessoal.png"
            alt="logo desenvolvimento pessoal"
            title="logo desenvolvimento pessoal"
          />
          <p>Desenvolvimento Pessoal</p>
        </router-link>
        <div class="content-menu d-lg-none">
          <a class="content-menu-item btn-menu" @click="setMenuOpen(false)">
            <span class="active"></span>
            <p>Fechar</p>
          </a>
        </div>
      </div>
      <div class="aside-menu-itens-body">
        <h2>Categorias</h2>
        <div class="aside-menu-itens-collapse">
          <router-link
            tag="a"
            :to="{ name: 'Blog' }"
            @click.native="setMenuOpen(false)"
            class="aside-menu-itens-collapse-btn"
          >
            Blog
            <svg
              width="7"
              height="12"
              viewBox="0 0 7 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_35_1490"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="7"
                height="12"
              >
                <path
                  d="M0.920705 12H7L7 0.543873H0.920705L0.920705 12Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0_35_1490)">
                <path
                  d="M6.77741 6.84966C7.0742 6.53013 7.0742 6.01118 6.77741 5.69165L2.21883 0.78349C1.92207 0.463963 1.44008 0.463963 1.14331 0.78349C0.846487 1.10307 0.846487 1.62196 1.14331 1.94155L5.16529 6.27191L1.14569 10.6023C0.848868 10.9219 0.848868 11.4408 1.14569 11.7603C1.44246 12.0799 1.92445 12.0799 2.22121 11.7603L6.77979 6.85221L6.77741 6.84966Z"
                  fill="black"
                />
              </g>
            </svg>
          </router-link>
          <!-- <button class="aside-menu-itens-collapse-btn" v-b-toggle.collapse-1>
            Blog
            <svg width="12" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_35_1461)">
              <mask id="mask0_35_1461" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="12" height="6">
              <path d="M0 0L0 6L11.4561 6V0L0 0Z" fill="white"/>
              </mask>
              <g mask="url(#mask0_35_1461)">
              <path d="M5.15034 5.78032C5.46987 6.07323 5.98882 6.07323 6.30835 5.78032L11.2165 1.2812C11.536 0.9883 11.536 0.5126 11.2165 0.2197C10.8969 -0.0732503 10.378 -0.0732503 10.0585 0.2197L5.72809 4.18922L1.39767 0.22205C1.07813 -0.0709 0.559195 -0.0709 0.239655 0.22205C-0.079885 0.51495 -0.079885 0.99065 0.239655 1.28354L5.14779 5.78266L5.15034 5.78032Z" fill="black"/>
              </g>
              </g>
              <defs>
              <clipPath id="clip0_35_1461">
              <rect width="6" height="12" fill="white" transform="matrix(0 -1 1 0 0 6)"/>
              </clipPath>
              </defs>
            </svg>
          </button>
          <b-collapse id="collapse-1">
            <div class="card-body">
              <router-link tag="a" :to="{name: 'Blog'}" @click.native="setMenuOpen(false)" class="card-body-links">
                Ver tudo
                <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <mask id="mask0_35_1490" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="7" height="12">
                  <path d="M0.920705 12H7L7 0.543873H0.920705L0.920705 12Z" fill="white"/>
                  </mask>
                  <g mask="url(#mask0_35_1490)">
                  <path d="M6.77741 6.84966C7.0742 6.53013 7.0742 6.01118 6.77741 5.69165L2.21883 0.78349C1.92207 0.463963 1.44008 0.463963 1.14331 0.78349C0.846487 1.10307 0.846487 1.62196 1.14331 1.94155L5.16529 6.27191L1.14569 10.6023C0.848868 10.9219 0.848868 11.4408 1.14569 11.7603C1.44246 12.0799 1.92445 12.0799 2.22121 11.7603L6.77979 6.85221L6.77741 6.84966Z" fill="black"/>
                  </g>
                </svg>
              </router-link>
            </div>
          </b-collapse> -->
        </div>
        <div class="aside-menu-itens-collapse">
          <router-link
            tag="a"
            :to="{ name: 'Ebooks' }"
            @click.native="setMenuOpen(false)"
            class="aside-menu-itens-collapse-btn"
          >
            Ebooks
            <svg
              width="7"
              height="12"
              viewBox="0 0 7 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_35_1490"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="7"
                height="12"
              >
                <path
                  d="M0.920705 12H7L7 0.543873H0.920705L0.920705 12Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0_35_1490)">
                <path
                  d="M6.77741 6.84966C7.0742 6.53013 7.0742 6.01118 6.77741 5.69165L2.21883 0.78349C1.92207 0.463963 1.44008 0.463963 1.14331 0.78349C0.846487 1.10307 0.846487 1.62196 1.14331 1.94155L5.16529 6.27191L1.14569 10.6023C0.848868 10.9219 0.848868 11.4408 1.14569 11.7603C1.44246 12.0799 1.92445 12.0799 2.22121 11.7603L6.77979 6.85221L6.77741 6.84966Z"
                  fill="black"
                />
              </g>
            </svg>
          </router-link>
          <!-- <button class="aside-menu-itens-collapse-btn" v-b-toggle.collapse-2>
            Ebooks
            <svg width="12" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_35_1461)">
              <mask id="mask0_35_1461" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="12" height="6">
              <path d="M0 0L0 6L11.4561 6V0L0 0Z" fill="white"/>
              </mask>
              <g mask="url(#mask0_35_1461)">
              <path d="M5.15034 5.78032C5.46987 6.07323 5.98882 6.07323 6.30835 5.78032L11.2165 1.2812C11.536 0.9883 11.536 0.5126 11.2165 0.2197C10.8969 -0.0732503 10.378 -0.0732503 10.0585 0.2197L5.72809 4.18922L1.39767 0.22205C1.07813 -0.0709 0.559195 -0.0709 0.239655 0.22205C-0.079885 0.51495 -0.079885 0.99065 0.239655 1.28354L5.14779 5.78266L5.15034 5.78032Z" fill="black"/>
              </g>
              </g>
              <defs>
              <clipPath id="clip0_35_1461">
              <rect width="6" height="12" fill="white" transform="matrix(0 -1 1 0 0 6)"/>
              </clipPath>
              </defs>
            </svg>
          </button>
          <b-collapse id="collapse-2">
            <div class="card-body">
              <router-link tag="a" :to="{name: 'Ebooks'}" @click.native="setMenuOpen(false)" class="card-body-links">
                Ver tudo
                <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <mask id="mask0_35_1490" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="7" height="12">
                  <path d="M0.920705 12H7L7 0.543873H0.920705L0.920705 12Z" fill="white"/>
                  </mask>
                  <g mask="url(#mask0_35_1490)">
                  <path d="M6.77741 6.84966C7.0742 6.53013 7.0742 6.01118 6.77741 5.69165L2.21883 0.78349C1.92207 0.463963 1.44008 0.463963 1.14331 0.78349C0.846487 1.10307 0.846487 1.62196 1.14331 1.94155L5.16529 6.27191L1.14569 10.6023C0.848868 10.9219 0.848868 11.4408 1.14569 11.7603C1.44246 12.0799 1.92445 12.0799 2.22121 11.7603L6.77979 6.85221L6.77741 6.84966Z" fill="black"/>
                  </g>
                </svg>
              </router-link>
            </div>
          </b-collapse> -->
        </div>
        <div class="aside-menu-itens-collapse">
          <router-link
            tag="a"
            :to="{ name: 'Plans' }"
            @click.native="setMenuOpen(false)"
            class="aside-menu-itens-collapse-btn"
          >
            Planos
            <svg
              width="7"
              height="12"
              viewBox="0 0 7 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_35_1490"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="7"
                height="12"
              >
                <path
                  d="M0.920705 12H7L7 0.543873H0.920705L0.920705 12Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0_35_1490)">
                <path
                  d="M6.77741 6.84966C7.0742 6.53013 7.0742 6.01118 6.77741 5.69165L2.21883 0.78349C1.92207 0.463963 1.44008 0.463963 1.14331 0.78349C0.846487 1.10307 0.846487 1.62196 1.14331 1.94155L5.16529 6.27191L1.14569 10.6023C0.848868 10.9219 0.848868 11.4408 1.14569 11.7603C1.44246 12.0799 1.92445 12.0799 2.22121 11.7603L6.77979 6.85221L6.77741 6.84966Z"
                  fill="black"
                />
              </g>
            </svg>
          </router-link>
          <!-- <button class="aside-menu-itens-collapse-btn" v-b-toggle.collapse-3>
            Planos
            <svg width="12" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_35_1461)">
              <mask id="mask0_35_1461" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="12" height="6">
              <path d="M0 0L0 6L11.4561 6V0L0 0Z" fill="white"/>
              </mask>
              <g mask="url(#mask0_35_1461)">
              <path d="M5.15034 5.78032C5.46987 6.07323 5.98882 6.07323 6.30835 5.78032L11.2165 1.2812C11.536 0.9883 11.536 0.5126 11.2165 0.2197C10.8969 -0.0732503 10.378 -0.0732503 10.0585 0.2197L5.72809 4.18922L1.39767 0.22205C1.07813 -0.0709 0.559195 -0.0709 0.239655 0.22205C-0.079885 0.51495 -0.079885 0.99065 0.239655 1.28354L5.14779 5.78266L5.15034 5.78032Z" fill="black"/>
              </g>
              </g>
              <defs>
              <clipPath id="clip0_35_1461">
              <rect width="6" height="12" fill="white" transform="matrix(0 -1 1 0 0 6)"/>
              </clipPath>
              </defs>
            </svg>
          </button>
          <b-collapse id="collapse-3">
            <div class="card-body">
              <router-link tag="a" :to="{name: 'Plans'}" @click.native="setMenuOpen(false)" class="card-body-links">
                Ver tudo
                <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <mask id="mask0_35_1490" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="7" height="12">
                  <path d="M0.920705 12H7L7 0.543873H0.920705L0.920705 12Z" fill="white"/>
                  </mask>
                  <g mask="url(#mask0_35_1490)">
                  <path d="M6.77741 6.84966C7.0742 6.53013 7.0742 6.01118 6.77741 5.69165L2.21883 0.78349C1.92207 0.463963 1.44008 0.463963 1.14331 0.78349C0.846487 1.10307 0.846487 1.62196 1.14331 1.94155L5.16529 6.27191L1.14569 10.6023C0.848868 10.9219 0.848868 11.4408 1.14569 11.7603C1.44246 12.0799 1.92445 12.0799 2.22121 11.7603L6.77979 6.85221L6.77741 6.84966Z" fill="black"/>
                  </g>
                </svg>
              </router-link>
            </div>
          </b-collapse> -->
        </div>
        <div class="aside-menu-itens-collapse">
          <router-link
            tag="a"
            :to="{ name: 'Meditation' }"
            @click.native="setMenuOpen(false)"
            class="aside-menu-itens-collapse-btn"
          >
            Meditação
            <svg
              width="7"
              height="12"
              viewBox="0 0 7 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_35_1490"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="7"
                height="12"
              >
                <path
                  d="M0.920705 12H7L7 0.543873H0.920705L0.920705 12Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0_35_1490)">
                <path
                  d="M6.77741 6.84966C7.0742 6.53013 7.0742 6.01118 6.77741 5.69165L2.21883 0.78349C1.92207 0.463963 1.44008 0.463963 1.14331 0.78349C0.846487 1.10307 0.846487 1.62196 1.14331 1.94155L5.16529 6.27191L1.14569 10.6023C0.848868 10.9219 0.848868 11.4408 1.14569 11.7603C1.44246 12.0799 1.92445 12.0799 2.22121 11.7603L6.77979 6.85221L6.77741 6.84966Z"
                  fill="black"
                />
              </g>
            </svg>
          </router-link>
          <!-- <button class="aside-menu-itens-collapse-btn" v-b-toggle.collapse-3>
            Planos
            <svg width="12" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_35_1461)">
              <mask id="mask0_35_1461" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="12" height="6">
              <path d="M0 0L0 6L11.4561 6V0L0 0Z" fill="white"/>
              </mask>
              <g mask="url(#mask0_35_1461)">
              <path d="M5.15034 5.78032C5.46987 6.07323 5.98882 6.07323 6.30835 5.78032L11.2165 1.2812C11.536 0.9883 11.536 0.5126 11.2165 0.2197C10.8969 -0.0732503 10.378 -0.0732503 10.0585 0.2197L5.72809 4.18922L1.39767 0.22205C1.07813 -0.0709 0.559195 -0.0709 0.239655 0.22205C-0.079885 0.51495 -0.079885 0.99065 0.239655 1.28354L5.14779 5.78266L5.15034 5.78032Z" fill="black"/>
              </g>
              </g>
              <defs>
              <clipPath id="clip0_35_1461">
              <rect width="6" height="12" fill="white" transform="matrix(0 -1 1 0 0 6)"/>
              </clipPath>
              </defs>
            </svg>
          </button>
          <b-collapse id="collapse-3">
            <div class="card-body">
              <router-link tag="a" :to="{name: 'Plans'}" @click.native="setMenuOpen(false)" class="card-body-links">
                Ver tudo
                <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <mask id="mask0_35_1490" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="7" height="12">
                  <path d="M0.920705 12H7L7 0.543873H0.920705L0.920705 12Z" fill="white"/>
                  </mask>
                  <g mask="url(#mask0_35_1490)">
                  <path d="M6.77741 6.84966C7.0742 6.53013 7.0742 6.01118 6.77741 5.69165L2.21883 0.78349C1.92207 0.463963 1.44008 0.463963 1.14331 0.78349C0.846487 1.10307 0.846487 1.62196 1.14331 1.94155L5.16529 6.27191L1.14569 10.6023C0.848868 10.9219 0.848868 11.4408 1.14569 11.7603C1.44246 12.0799 1.92445 12.0799 2.22121 11.7603L6.77979 6.85221L6.77741 6.84966Z" fill="black"/>
                  </g>
                </svg>
              </router-link>
            </div>
          </b-collapse> -->
        </div>
        <div class="aside-menu-itens-collapse">
          <router-link
            tag="a"
            :to="{ name: 'Humor' }"
            @click.native="setMenuOpen(false)"
            class="aside-menu-itens-collapse-btn"
          >
            Humor
            <svg
              width="7"
              height="12"
              viewBox="0 0 7 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_35_1490"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="7"
                height="12"
              >
                <path
                  d="M0.920705 12H7L7 0.543873H0.920705L0.920705 12Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0_35_1490)">
                <path
                  d="M6.77741 6.84966C7.0742 6.53013 7.0742 6.01118 6.77741 5.69165L2.21883 0.78349C1.92207 0.463963 1.44008 0.463963 1.14331 0.78349C0.846487 1.10307 0.846487 1.62196 1.14331 1.94155L5.16529 6.27191L1.14569 10.6023C0.848868 10.9219 0.848868 11.4408 1.14569 11.7603C1.44246 12.0799 1.92445 12.0799 2.22121 11.7603L6.77979 6.85221L6.77741 6.84966Z"
                  fill="black"
                />
              </g>
            </svg>
          </router-link>
          <!-- <button class="aside-menu-itens-collapse-btn" v-b-toggle.collapse-3>
            Planos
            <svg width="12" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_35_1461)">
              <mask id="mask0_35_1461" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="12" height="6">
              <path d="M0 0L0 6L11.4561 6V0L0 0Z" fill="white"/>
              </mask>
              <g mask="url(#mask0_35_1461)">
              <path d="M5.15034 5.78032C5.46987 6.07323 5.98882 6.07323 6.30835 5.78032L11.2165 1.2812C11.536 0.9883 11.536 0.5126 11.2165 0.2197C10.8969 -0.0732503 10.378 -0.0732503 10.0585 0.2197L5.72809 4.18922L1.39767 0.22205C1.07813 -0.0709 0.559195 -0.0709 0.239655 0.22205C-0.079885 0.51495 -0.079885 0.99065 0.239655 1.28354L5.14779 5.78266L5.15034 5.78032Z" fill="black"/>
              </g>
              </g>
              <defs>
              <clipPath id="clip0_35_1461">
              <rect width="6" height="12" fill="white" transform="matrix(0 -1 1 0 0 6)"/>
              </clipPath>
              </defs>
            </svg>
          </button>
          <b-collapse id="collapse-3">
            <div class="card-body">
              <router-link tag="a" :to="{name: 'Plans'}" @click.native="setMenuOpen(false)" class="card-body-links">
                Ver tudo
                <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <mask id="mask0_35_1490" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="7" height="12">
                  <path d="M0.920705 12H7L7 0.543873H0.920705L0.920705 12Z" fill="white"/>
                  </mask>
                  <g mask="url(#mask0_35_1490)">
                  <path d="M6.77741 6.84966C7.0742 6.53013 7.0742 6.01118 6.77741 5.69165L2.21883 0.78349C1.92207 0.463963 1.44008 0.463963 1.14331 0.78349C0.846487 1.10307 0.846487 1.62196 1.14331 1.94155L5.16529 6.27191L1.14569 10.6023C0.848868 10.9219 0.848868 11.4408 1.14569 11.7603C1.44246 12.0799 1.92445 12.0799 2.22121 11.7603L6.77979 6.85221L6.77741 6.84966Z" fill="black"/>
                  </g>
                </svg>
              </router-link>
            </div>
          </b-collapse> -->
        </div>
        <div class="aside-menu-itens-collapse">
          <router-link
            tag="a"
            :to="{ name: 'Professional' }"
            @click.native="setMenuOpen(false)"
            class="aside-menu-itens-collapse-btn"
          >
            Profissional
            <svg
              width="7"
              height="12"
              viewBox="0 0 7 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_35_1490"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="7"
                height="12"
              >
                <path
                  d="M0.920705 12H7L7 0.543873H0.920705L0.920705 12Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0_35_1490)">
                <path
                  d="M6.77741 6.84966C7.0742 6.53013 7.0742 6.01118 6.77741 5.69165L2.21883 0.78349C1.92207 0.463963 1.44008 0.463963 1.14331 0.78349C0.846487 1.10307 0.846487 1.62196 1.14331 1.94155L5.16529 6.27191L1.14569 10.6023C0.848868 10.9219 0.848868 11.4408 1.14569 11.7603C1.44246 12.0799 1.92445 12.0799 2.22121 11.7603L6.77979 6.85221L6.77741 6.84966Z"
                  fill="black"
                />
              </g>
            </svg>
          </router-link>
          <!-- <button class="aside-menu-itens-collapse-btn" v-b-toggle.collapse-3>
            Planos
            <svg width="12" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_35_1461)">
              <mask id="mask0_35_1461" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="12" height="6">
              <path d="M0 0L0 6L11.4561 6V0L0 0Z" fill="white"/>
              </mask>
              <g mask="url(#mask0_35_1461)">
              <path d="M5.15034 5.78032C5.46987 6.07323 5.98882 6.07323 6.30835 5.78032L11.2165 1.2812C11.536 0.9883 11.536 0.5126 11.2165 0.2197C10.8969 -0.0732503 10.378 -0.0732503 10.0585 0.2197L5.72809 4.18922L1.39767 0.22205C1.07813 -0.0709 0.559195 -0.0709 0.239655 0.22205C-0.079885 0.51495 -0.079885 0.99065 0.239655 1.28354L5.14779 5.78266L5.15034 5.78032Z" fill="black"/>
              </g>
              </g>
              <defs>
              <clipPath id="clip0_35_1461">
              <rect width="6" height="12" fill="white" transform="matrix(0 -1 1 0 0 6)"/>
              </clipPath>
              </defs>
            </svg>
          </button>
          <b-collapse id="collapse-3">
            <div class="card-body">
              <router-link tag="a" :to="{name: 'Plans'}" @click.native="setMenuOpen(false)" class="card-body-links">
                Ver tudo
                <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <mask id="mask0_35_1490" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="7" height="12">
                  <path d="M0.920705 12H7L7 0.543873H0.920705L0.920705 12Z" fill="white"/>
                  </mask>
                  <g mask="url(#mask0_35_1490)">
                  <path d="M6.77741 6.84966C7.0742 6.53013 7.0742 6.01118 6.77741 5.69165L2.21883 0.78349C1.92207 0.463963 1.44008 0.463963 1.14331 0.78349C0.846487 1.10307 0.846487 1.62196 1.14331 1.94155L5.16529 6.27191L1.14569 10.6023C0.848868 10.9219 0.848868 11.4408 1.14569 11.7603C1.44246 12.0799 1.92445 12.0799 2.22121 11.7603L6.77979 6.85221L6.77741 6.84966Z" fill="black"/>
                  </g>
                </svg>
              </router-link>
            </div>
          </b-collapse> -->
        </div>
        <div class="aside-menu-itens-collapse">
          <router-link
            tag="a"
            :to="{ name: 'ContentPages' }"
            @click.native="setMenuOpen(false)"
            class="aside-menu-itens-collapse-btn"
          >
            Conteúdos das páginas
            <svg
              width="7"
              height="12"
              viewBox="0 0 7 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_35_1490"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="7"
                height="12"
              >
                <path
                  d="M0.920705 12H7L7 0.543873H0.920705L0.920705 12Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0_35_1490)">
                <path
                  d="M6.77741 6.84966C7.0742 6.53013 7.0742 6.01118 6.77741 5.69165L2.21883 0.78349C1.92207 0.463963 1.44008 0.463963 1.14331 0.78349C0.846487 1.10307 0.846487 1.62196 1.14331 1.94155L5.16529 6.27191L1.14569 10.6023C0.848868 10.9219 0.848868 11.4408 1.14569 11.7603C1.44246 12.0799 1.92445 12.0799 2.22121 11.7603L6.77979 6.85221L6.77741 6.84966Z"
                  fill="black"
                />
              </g>
            </svg>
          </router-link>
        </div>
        <div class="aside-menu-itens-collapse">
          <router-link
            tag="a"
            :to="{ name: 'Company' }"
            @click.native="setMenuOpen(false)"
            class="aside-menu-itens-collapse-btn"
          >
            Empresa
            <svg
              width="7"
              height="12"
              viewBox="0 0 7 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_35_1490"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="7"
                height="12"
              >
                <path
                  d="M0.920705 12H7L7 0.543873H0.920705L0.920705 12Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0_35_1490)">
                <path
                  d="M6.77741 6.84966C7.0742 6.53013 7.0742 6.01118 6.77741 5.69165L2.21883 0.78349C1.92207 0.463963 1.44008 0.463963 1.14331 0.78349C0.846487 1.10307 0.846487 1.62196 1.14331 1.94155L5.16529 6.27191L1.14569 10.6023C0.848868 10.9219 0.848868 11.4408 1.14569 11.7603C1.44246 12.0799 1.92445 12.0799 2.22121 11.7603L6.77979 6.85221L6.77741 6.84966Z"
                  fill="black"
                />
              </g>
            </svg>
          </router-link>
        </div>
        <a
          class="content-header-itens-logoff d-lg-none"
          @click="signOutUser(), setMenuOpen(false)"
        >
          <p>Sair</p>
          <img
            class="img-fluid"
            src="@/assets/img/icon-logoff.png"
            alt="icon logoff"
            title="icon logoff"
          />
        </a>
      </div>
    </div>
  </aside>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["menuOpen"]),
  },
  methods: {
    ...mapActions(["setMenuOpen"]),
    ...mapActions("User", ["signOutUser"]),
  },
};
</script>

<style lang="scss">
.aside-menu {
  width: 300px;
  min-height: 100vh;
  background: linear-gradient(to bottom, var(--orange-2), var(--yellow-2));
  @media (max-width: 991px) {
    position: fixed;
    top: 0px;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 30px;
    transition: 0.8s ease-in-out;
    left: -100%;
    pointer-events: none;
    z-index: 1030;
  }
  &-active {
    left: 0;
    pointer-events: initial;
  }
  &-itens {
    height: 100%;
    &-header {
      padding: 30px 20px 20px 20px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.4);
      @media (max-width: 991px) {
        padding-top: 80px;
      }
      &--logo {
        display: flex;
        align-items: center;
        @media (max-width: 991px) {
          justify-content: center;
        }
        p {
          font-size: 16px;
          font-family: "Font Semibold";
          color: var(--white);
          margin-left: 15px;
          margin-bottom: 0;
        }
      }
    }
    &-body {
      padding: 30px 20px;
      h2 {
        font-size: 14px;
        font-family: "Font Regular";
        color: var(--white);
        text-align: left;
        margin-bottom: 20px;
      }
    }
    .card {
      border: 0;
      background: 0;
      border-radius: 0px;
      &-header {
        border: 0;
        background: 0;
        border-radius: 0px;
        padding: 0;
      }
      &-body {
        padding: 0;
        &-links {
          position: relative;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 14px;
          color: var(--black);
          font-family: "Font Light";
          padding: 10px 15px;
          background: var(--gray-light-2);
          transition: 500ms;
          &:last-child {
            &::after {
              content: none;
            }
          }
          &::after {
            content: "";
            display: block;
            width: calc(100% - 30px);
            height: 1px;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: 0;
            background: rgba(0, 0, 0, 0.05);
          }
          &:hover,
          &:focus {
            cursor: pointer;
          }
        }
      }
    }
    &-collapse {
      border-bottom: 1px solid var(--orange);
      &:first-of-type {
        .aside-menu-itens-collapse-btn {
          border-radius: 10px 10px 0px 0px;
        }
      }
      &:last-of-type {
        border-bottom: 0;
        .aside-menu-itens-collapse-btn:not([aria-expanded="true"]) {
          border-radius: 0px 0px 10px 10px;
        }
        .card-body-links:last-child {
          border-radius: 0px 0px 10px 10px;
        }
      }
      &-btn {
        position: relative;
        width: 100%;
        padding: 10px 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: var(--white);
        border: 0;
        font-size: 14px;
        font-family: "Font Semibold";
        color: var(--black) !important;
        box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
        transition: 500ms;
        z-index: 1;
        &:hover,
        &:focus {
          cursor: pointer;
          opacity: 0.9;
        }
        svg {
          transition: 500ms;
        }
        &[aria-expanded="true"] {
          & > svg {
            transform: rotate(180deg);
          }
        }
      }
    }
    .content-menu {
      position: absolute;
      top: 20px;
      left: 15px;
      &-item {
        span {
          &::before,
          &::after {
            background: var(--white);
          }
        }
        p {
          color: var(--white);
        }
      }
    }
  }
}
</style>
